module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "parent"
  }, [_c('div', {
    staticClass: "mod scroll"
  }, [_c('div', {
    staticClass: "mod-head"
  }, [_c('h1', {
    staticClass: "text-center fz16"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-times pull-right",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mod-body",
    domProps: {
      "innerHTML": _vm._s(_vm.dbody)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@12.1.0/~/vue-loader/lib/template-compiler?{"id":"data-v-a92f2e62"}!./~/.store/vue-loader@12.1.0/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/bdDialog/template.vue
// module id = 919
// module chunks = 76